<template>
    <hts-tooltip>
        <template #reference>
            <hts-icons
                svg="globe-dark"
                class-name="h-20 w-20 cursor-pointer transition-all hover:text-gray-500"
                :class="{
                    '!fill-gray-700': showMap,
                    '!fill-gray-300': !showMap
                }"
                @click="change" />
        </template>
        <span>
            {{ label }}
        </span>
    </hts-tooltip>
</template>
<script setup lang="ts">
const props = defineProps({
  label: {
    type: String,
    default: 'Ẩn/hiện bản đồ'
  },
  storeKey: {
    type: String,
    default: 'system'
  }
})

const { label, storeKey } = toRefs(props)

const { map } = $store()

const showMap = computed(() => {
  if (!map) {
    return
  }
  return map.getShowMap[storeKey.value]
})

const change = () => {
  if (!map) {
    return
  }

  map.setShowMap({ [storeKey.value]: !showMap.value })
}
</script>
